import { render } from "./UserDropdown.vue?vue&type=template&id=f74ff1e6&scoped=true"
import script from "./UserDropdown.vue?vue&type=script&lang=js"
export * from "./UserDropdown.vue?vue&type=script&lang=js"

import "./UserDropdown.vue?vue&type=style&index=0&id=f74ff1e6&lang=scss&scoped=true"

import exportComponent from "/Users/intr0vert/Git/ai-startup/aibanner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f74ff1e6"]])

export default __exports__